import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { PatientbookletData, PatientbookletMst } from '../../../interfaces/masters/patientbooklet';
import { PatientbookletApi } from '../api/patientbooklet.api';

@Injectable()
export class PatientbookletService extends PatientbookletData {

  constructor(private api: PatientbookletApi) { 
    super();   
  }

  list(url: string): Observable<PatientbookletMst[]> {
    return this.api.list(url);
  }
  getById(url:string): Observable<PatientbookletMst>{
      return this.api.getById(url); 
  }
  create(url: string, data:PatientbookletMst): Observable<PatientbookletMst> {
    return this.api.add(url,data);
  }
  update(url: string, data:PatientbookletMst): Observable<PatientbookletMst> {
    return this.api.update(url,data);
  }  
  delete(url: string): Observable<boolean> { 
    return this.api.delete(url);
  } 
}
